<template>
  <el-dialog
    title="绑定授权码"
    :visible.sync="list"
    width="30%"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <el-input
      v-model.trim="input"
      placeholder="请输入授权码"
      clearable
      maxlength="18"
    ></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="CardBuCardNo">确 定</el-button>
    </span>
    <el-dialog
      title="绑定授权码"
      :visible.sync="GetdialogVisiblefalse"
      width="30%"
      :before-close="handleClose2"
      :append-to-body="true"
    >
      <div>{{ error.msg }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="GetdialogVisiblefalse = false">取 消</el-button>
        <el-button type="primary" @click="GetdialogVisiblefalse = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="绑定授权码"
      :visible.sync="GetdialogVisibleok"
      width="30%"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <div>
        您正在绑定的是
        <span class="bluex">{{ name }}</span>
        授权码，绑定后不可删除，是否确定绑定？?
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="GetdialogVisibleok = false">取 消</el-button>
        <el-button type="primary" @click="UsingCardPwd">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import {
  selectCardBuCardNo,
  selectIsUsingCardPwd,
  updateCode,
} from "@/api/user/myResources.js";
export default {
  data() {
    return {
      input: "",
      binding: "",
      name: "",
      error: "",
      dialogVisible: false,
      GetdialogVisible: false,
      GetdialogVisibleok: false,
      GetdialogVisiblefalse: false,
    };
  },
  props: {
    list: Boolean,
  },
  watch: {
    list: {
      handler() {
        this.input = "";
      },
    },
  },
  methods: {
    handleClose() {
      this.GetdialogVisibleok = false;
      this.$emit("getShow", false);
    },
    handleClose2() {
      this.GetdialogVisiblefalse = false;
    },
    getboox() {
      this.GetdialogVisible = true;
    },
    CardBuCardNo() {
      console.log(this.input);
      if (this.input == "") {
        this.$message("授权码不能为空");
        return;
      }
      selectCardBuCardNo({ cardPwd: this.input })
        .then((res) => {
          if (res.code === 200) {
            this.name = res.data.name;
            this.GetdialogVisibleok = true;
          }
        })
        .catch((error) => {
          this.GetdialogVisiblefalse = false;
          // this.$emit("getShow", false);
          this.error = error;
        });
    },
    UsingCardPwd() {
      // selectIsUsingCardPwd().then((res) => {
      //   if (res.data) {
      let arr = {
        cardPwd: this.input,
        // isUsingCardPwd: res.data,
      };
      updateCode(arr).then((res) => {
        this.$message({
          type: "success",
          message: "已绑定此授权码，请前往书架查看",
        });
        this.GetdialogVisibleok = false;
        this.input = "";
        this.$emit("getShow", false);
      });
      //   }
      // });
    },
  },
};
</script>
<style scoped  lang="scss">
.bluex {
  color: blue;
}
</style>
<style scoped  lang="scss">
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
::v-deep .el-input__inner {
  line-height: 1px !important;
}
</style>